/**
 * Реестр якорей онбординга (ТЗ §4.1).
 *
 * Шаг манифеста ссылается на элемент интерфейса только через ключ из этого списка.
 * Прямые CSS-селекторы и поиск по тексту запрещены: Tailwind-классы и i18n-строки
 * нестабильны между релизами, а ключ якоря проверяется CI-гейтом G-1.
 */

export const ONBOARDING_ANCHORS = [
  'mailbox.addButton',
  'mailbox.quotaBlock',
  'mailbox.forwardingBanner',
  'mailbox.card.menu',
  'mailbox.card.first',
] as const;

export type OnboardingAnchor = (typeof ONBOARDING_ANCHORS)[number];

/** Атрибут, по которому движок находит элемент в DOM. */
export const ANCHOR_ATTRIBUTE = 'data-onboarding-id';

export function isOnboardingAnchor(value: string): value is OnboardingAnchor {
  return (ONBOARDING_ANCHORS as readonly string[]).includes(value);
}

export function anchorSelector(anchor: OnboardingAnchor): string {
  return `[${ANCHOR_ATTRIBUTE}="${anchor}"]`;
}
